import { useStore } from "../store";
import { SettingsContainer } from "./SettingsContainer";
import { BroadcastInfoSettings } from "./BroadcastInfoSettings";
import { BroadcastTimeSettings } from "./BroadcastTimeSettings";
import { fetchBroadcasts } from "../info";

const style = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateAreas: "'broadcast time' 'save save'",
  margin: 80,
  gap: 36
};

export function BroadcastSettings(props) {
  const { anime, broadcast, setBroadcast } = useStore();

  async function onSave() {
    const broadcasts = await fetchBroadcasts(anime.id);
    setBroadcast(broadcasts.find(b => b.id === broadcast.id));
  }

  return (<>
    <div style={ style }>
      <SettingsContainer gridArea="broadcast">
        <BroadcastInfoSettings key={ Math.random() } broadcast={ broadcast } onSave={ onSave }/>
      </SettingsContainer>

      <SettingsContainer gridArea="time">
        <BroadcastTimeSettings key={ Math.random() } anime={ anime } broadcast={ broadcast } onSave={ onSave }/>
      </SettingsContainer>
    </div>
  </>);
}
